import { NumberParam, NumericArrayParam, StringParam, withDefault } from 'use-query-params';

export const filterParams = {
  startDate: StringParam,
  finishDate: StringParam,
  companies: NumericArrayParam,
  page: withDefault(NumberParam, 1),
  size: withDefault(NumberParam, 10)
};
